export var TableQuantityTotalMode;
(function (TableQuantityTotalMode) {
    TableQuantityTotalMode[TableQuantityTotalMode["Total"] = 0] = "Total";
    TableQuantityTotalMode[TableQuantityTotalMode["Net"] = 1] = "Net";
})(TableQuantityTotalMode || (TableQuantityTotalMode = {}));
